var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsgActionEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2452 2.8173C14.332 1.7305 16.0941 1.7305 17.1809 2.8173C18.2224 3.85883 18.2658 5.52051 17.3111 6.61371L17.1809 6.75298L7.57506 16.3588C7.36997 16.5639 7.12323 16.7214 6.85236 16.8212L6.68708 16.8741L2.63211 17.98C2.28552 18.0745 1.96546 17.786 2.00301 17.4454L2.01817 17.3661L3.12407 13.3111C3.20039 13.0313 3.33646 12.7721 3.52212 12.551L3.63939 12.4231L13.2452 2.8173ZM12.385 5.0922L4.34649 13.1302C4.2542 13.2225 4.18117 13.3317 4.13111 13.4513L4.08884 13.5742L3.2122 16.7849L6.42397 15.9094C6.50791 15.8865 6.58815 15.8528 6.66278 15.8095L6.77028 15.7374L6.86796 15.6517L14.906 7.6132L12.385 5.0922ZM16.4738 3.52441C15.8162 2.86681 14.7727 2.83028 14.0722 3.41481L13.9523 3.52441L13.092 4.3852L15.613 6.9062L16.4738 6.04587C17.1314 5.38827 17.1679 4.34479 16.5834 3.64431L16.4738 3.52441Z",
    fill: "#2A3842"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgActionEdit);
export default __webpack_public_path__ + "static/media/msg-action-edit.1c9a43cb109ebe7879681d9b1ad4114e.svg";
export { ForwardRef as ReactComponent };